export class LoginModel {
  email: string;
  password: string;
  rememberMe: boolean;

  public constructor(init?: any) {
    Object.assign(this, init);
  }
}
